/**
 * 所属企業
 */
export interface WorkingCompany {
  companyId: string
  excluded: boolean
}

export namespace WorkingCompany {
  export namespace firestore {
    export const parentDocumentPath = ({ userId }: { userId: string }) =>
      `Company/v2/users/${userId}`
    export const collectionPath = ({ userId }: { userId: string }) =>
      `Company/v2/users/${userId}/workingCompanies`
    export type ParameterOfCollectionPath = Parameters<typeof collectionPath>[0]
  }
}
